import React from 'react';
import { IAnimationContext } from './types';

export const AnimationContext = React.createContext<IAnimationContext>({
  disableAnimations: false,
});
